// src/stores/auth.ts
import { create } from "zustand";
import { User } from "firebase/auth";

interface AuthState {
  user: User | null;
  isLoading: boolean;
  isAdmin: boolean;
  betaDenied: boolean;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  setAdmin: (isAdmin: boolean) => void;
  setBetaDenied: (denied: boolean) => void;
  signOut: () => void;
}

// Do NOT persist auth state — Firebase Auth's browserLocalPersistence
// already handles session persistence.  Persisting the User object in
// Zustand causes a stale plain-object to be hydrated on reload, which
// races with onAuthStateChanged and can leave the app in a broken state.
export const useAuthStore = create<AuthState>()((set) => ({
  user: null,
  isLoading: true,
  isAdmin: false,
  betaDenied: false,
  setUser: (user) => set({ user, isLoading: false }),
  setLoading: (isLoading) => set({ isLoading }),
  setAdmin: (isAdmin) => set({ isAdmin }),
  setBetaDenied: (betaDenied) => set({ betaDenied }),
  signOut: () => set({ user: null, isAdmin: false }),
}));
